import 'platform/platform.js'


export const platform = window[ 'platform' ];
